import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PageActions',
  setup(__props) {


const ui = useUiStore()

// Only show menu if we have actions
const showMenu = computed(() => ui.pageActions.length > 0)


return (_ctx: any,_cache: any) => {
  const _component_hy_menu = _resolveComponent("hy-menu")!

  return (_unref(showMenu))
    ? (_openBlock(), _createBlock(_component_hy_menu, {
        key: 0,
        items: _ctx.$ui.pageActions,
        "icon-color": "white",
        size: _ctx.$ui.mobile ? 'small' : 'large'
      }, null, 8, ["items", "size"]))
    : _createCommentVNode("", true)
}
}

})